export const THIS_TIME = '2022年1月17日—2022年2月8日'; // 本次预约时间
export const OVER_TIME = '2022年2月8日12:00'; // 截止时间
export const PUBLISH_TIME = '2022年2月9日请查询官博'; // 名单公布时间
export const RESERVE_NUM = 5; // 直播预约次数